import { type CURRENCY, type CurrencyEnumBaseData, type CurrencyEnumBaseExtraData, currencyEnumBase } from '@nfctron/nexus-core';

import { EnumHelper } from './helpers';

export interface CurrencyEnumTicketsExtraDataExtend {}

export interface CurrencyEnumTicketsData extends CurrencyEnumBaseData, CurrencyEnumTicketsExtraDataExtend {}

/**
 * Currency enumeration with extra data for Tickets
 * @extends {typeof currencyEnumBase} Base currency enumeration
 */
class CurrencyEnumTickets extends EnumHelper<CurrencyEnumBaseExtraData, CURRENCY, typeof currencyEnumBase.enumName, typeof currencyEnumBase.idKey> {
	constructor() {
		super(currencyEnumBase.enumName, currencyEnumBase.data, currencyEnumBase.idKey, null);
	}
}

export const currencyEnumTickets = new CurrencyEnumTickets();
